import type { CallbacksData, CallbackItem as ICallBackItem } from '@/shared/constant/ResourceData';
import { Collapse } from 'aui';
import clsx from 'clsx';
import { CallbackListItem } from './CallbackListItem';
import styles from './CallbacksList.module.css';

type CallbacksListProps = {
  className?: string;
  onSelect?: (apiDetail: ICallBackItem, name: string) => void;
  data: CallbacksData;
};

export function CallbacksList({ className, onSelect, data }: CallbacksListProps) {
  return (
    <>
      {Object.keys(data).map((name) => {
        return (
          <Collapse
            accordion
            expandIconPosition="left"
            defaultActiveKey={name}
            className={clsx(styles.collapse, 'mb-4 overflow-hidden last:mb-0')}
            key={name}
          >
            <Collapse.Panel header={<h2 className="text-lg font-600">{name}</h2>} key={name}>
              <ul className={clsx(className, 'm-0 overflow-hidden p-0')}>
                {data[name]!.map((item) => (
                  <CallbackListItem
                    key={item.id}
                    className="cursor-pointer border-b border-color-split last:border-b-0 hover:bg-btn-text-hover"
                    selected={false}
                    onClick={() => onSelect?.(item, name)}
                    apiDetail={item}
                  />
                ))}
              </ul>
            </Collapse.Panel>
          </Collapse>
        );
      })}
    </>
  );
}
